import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_URL || 'https://api.faster.com';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token and organization headers
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      // Web: Use localStorage
      const token = localStorage.getItem('web_auth_token');
      const organizationId = localStorage.getItem('web_org_id');

      console.log('Token:', token ? 'Present' : 'Missing');
      console.log('Organization ID:', organizationId);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (organizationId) {
        config.headers['Organization-Id'] = organizationId;
      }
    } catch (error) {
      console.error('Error setting headers:', error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Clear stored auth data
      localStorage.removeItem('web_auth_token');
      localStorage.removeItem('web_org_id');
      localStorage.removeItem('web_org_name');
      localStorage.removeItem('web_user_id');
      localStorage.removeItem('web_user_email');
      localStorage.removeItem('web_user_name');
      localStorage.removeItem('web_plugin_id');
      localStorage.removeItem('web_plugin_name');
      localStorage.removeItem('web_plugin_package');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;